import React from 'react';

import { translate } from 'react-i18next';

var NutritionLabel = React.createClass({

    render() {
        const { t } = this.props;
        
        let productName = '';
        let fcc = '';
        let taxes = 'Varies by Location';
        let labelClass = 'fusion';

        switch (this.props.product.product_key) {
            case 'xgspon_fusion':
            case 'xgspon_fusion_preorder':
                productName = "Fusion Fiber 10 Gigabits";
                fcc = "F0016027104FSFITENGB135792";
                break;
            case 'xgspon_standard':
            case 'xgspon_standard_preorder':
                productName = "Standard Fiber 10 Gigabits";
                fcc = "F0016027104STFITENGB246801";
                taxes = "Included in Price";
                labelClass = "standard";
                break;
            case 'xgspon_basic':
                productName = "Basic Fiber 10 Gigabits";
                fcc = "F0016027104BAFITENGB579135";
                taxes = "Included in Price";
                labelClass = "basic";
                break;
            case 'fusion_fiber':
                productName = "Fusion Fiber 1 Gigabit";
                fcc = "F0016027104FSFIONEGB357902";
                break;
            case 'fusion_fiber_business':
                productName = "Fusion Fiber 1 Gigabit Small Business";
                fcc = "F0016027104FSFIONEGBSMB135";
                break;
            case 'xgspon_business_fusion':
            case 'xgspon_business_fusion_preorder':
                productName = "Fusion Fiber 10 Gigabit Small Business";
                fcc = "F0016027104FSFITENGBSMB247";
                break;
            case 'xgspon_business_standard':
            case 'xgspon_business_standard_preorder':
                productName = "Standard Fiber 10 Gigabit Small Business";
                fcc = "F0016027104STFITENGBSMB358";
                labelClass = "standard";
                break;
        }

        let postIntro = '';
        let not = ' not';
        let mrc = this.props.product.mrc;
        
        if (this.props.product.product_key.startsWith('fusion_')) {
            mrc = mrc - 10;
            postIntro = `Introductory price \$${mrc} includes $10 discount for first 12 months of service. Price is \$${this.props.product.mrc} after first 12 months.`;
            not = '';
        }

        return (
            <div className={("bbfl" + " bbfl__" + labelClass)} style={{'text-align':'left'}}>
                <div className="bbfl__header">
                    <h1>Broadband Facts</h1>
                    <div className="bbfl__company">Sonic Internet</div>
                    <div className="bbfl__product">{productName}</div>
                    <div className="bbfl__type">Fixed Broadband Consumer Disclosure</div>
                </div>
                <div className="bbfl__price">
                    <dl>
                        <div className="bbfl__di">
                            <dt><h2>Monthly Price</h2></dt>
                            <dd>${mrc}</dd>
                        </div>
                    </dl>
                    <div className="bbfl__price-details">
                        <p>This Monthly Price is{not} an introductory rate for the first 12
                            months. {postIntro}</p>
                        <p>This Monthly Price does not require a contract.</p>
                    </div>
                </div>
                <div className="bbfl__additional">
                    <h3>Additional Charges &amp; Terms</h3>
                    <div className="bbfl__ml">
                        <div className="bbfl__mb">
                            <div>Provider Monthly Fees</div>
                            <div className="bbfl__ml">
                                <dl>
                                    <div className="bbfl__di">
                                        <dt>Optional WiFi device</dt>
                                        {(this.props.product.product_key == "xgspon_basic" ? 
                                            <dd>Starting at $0</dd> : 
                                            <dd>Starting at $5</dd>
                                        )}
                                    </div>
                                </dl>
                            </div>
                        </div>
                        <div className="bbfl__mb">
                            <dl>
                                <div className="bbfl__di">
                                    <dt>One-time Fees at the Time of Purchase</dt>
                                    {( this.props.product.product_key.includes('business') ?
                                        <dd>Installation Fee: $150</dd> :
                                        <dd>$0</dd>
                                    )}
                                </div>
                            </dl>
                        </div>
                        <div className="bbfl__mb">
                            <dl>
                                <div className="bbfl__di">
                                    <dt>Early Termination Fee</dt>
                                    <dd>$0</dd>
                                </div>
                            </dl>
                        </div>
                        <div className="bbfl__mb">
                            <dl>
                                <div className="bbfl__di">
                                    <dt>Governmental Taxes and Fees</dt>
                                    <dd>{taxes}</dd>
                                </div>
                            </dl>
                        </div>
                    </div>
                </div>
                <div className="bbfl__discounts">
                    <h3>Discounts &amp; Bundles</h3>
                    <div className="bbfl__ml">
                        <dl>
                            {( this.props.product.product_key.includes('standard') ?
                                <dt>Billing discounts and pricing options for broadband service bundles are not available.</dt> :
                                <dt>Includes one bundled phone line.</dt>
                            )}
                        </dl>
                    </div>
                </div>
                <div className="bbfl__speeds">
                    <h3>Speeds Provided with Plan</h3>
                    <div className="bbfl__ml">
                        <dl>
                            <div className="bbfl__di">
                                <dt>Typical Download Speed</dt>
                                {(this.props.product.access_downstream_speed == 10000 ?
                                    <dd>8,700 Mbps</dd> :
                                    <dd>940 Mbps</dd>
                                )}
                            </div>
                            <div className="bbfl__di">
                                <dt>Typical Upload Speed</dt>
                                {(this.props.product.access_upstream_speed == 10000 ?
                                    <dd>8,700 Mbps</dd> :
                                    <dd>940 Mbps</dd>
                                )}
                            </div>
                            <div className="bbfl__di">
                                <dt>Typical Latency</dt>
                                <dd>3ms</dd>
                            </div>
                        </dl>
                    </div>
                </div>
                <div className="bbfl__data">
                    <dl>
                        <div className="bbfl__di">
                            <dt><h3>Data Included with Monthly Price</h3></dt>
                            <dd>Unlimited</dd>
                        </div>
                    </dl>
                    <div className="bbfl__ml">
                        <dl>
                            <div className="bbfl__di">
                                <dt>Charges for Additional Data Usage</dt>
                                <dd>$0/GB</dd>
                            </div>
                        </dl>
                    </div>
                </div>
                <div className="bbfl__policies">
                    <dl>
                        <div className="bbfl__di">
                            <dt><h3>Network Management</h3></dt>
                            <dd><a href="https://www.sonic.com/broadband-facts/network-management" target="_blank">Read our
                                Policy</a></dd>
                        </div>
                    </dl>
                    <dl>
                        <div className="bbfl__di">
                            <dt><h3>Privacy</h3></dt>
                            <dd><a href="https://www.sonic.com/broadband-facts/privacy" target="_blank">Read our Policy</a></dd>
                        </div>
                    </dl>
                </div>
                <div className="bbfl__support">
                    <h3>Customer Support</h3>
                    <div className="bbfl__ml">
                        <span>Contact Us:</span>
                        <a href="https://www.sonic.com/support" target="_blank">sonic.com/support</a>
                        <span className="bbfl__phone">(855) 394-0100</span>
                    </div>
                </div>
                <div className="bbfl__fcc">
                    <p>Learn more about the terms used on this label by visiting the Federal Communications Commission’s Consumer
                        Resource Center.</p>
                    <div className="bbfl__fcc-url"><a href="https://fcc.gov/consumers" target="_blank">fcc.gov/consumers</a></div>
                </div>
                <div className="bbfl__upi">{fcc}</div>
            </div>
        );
    }
});

export default translate('common', { wait: true })(NutritionLabel);